// client/src/flow/components/UgitsLogo.js
import React from 'react';

const UgitsLogo = ({ style = {} }) => {
  return (
    <div style={{
      textAlign: 'center',
      padding: '20px',
      ...style
    }}>
      <h1 style={{
        fontSize: '48px',
        fontWeight: '900',
        margin: '0',
        background: 'linear-gradient(135deg, #6D28D9 0%, #059669 100%)',
        WebkitBackgroundClip: 'text',
        WebkitTextFillColor: 'transparent',
        backgroundClip: 'text',
        textTransform: 'uppercase',
        letterSpacing: '2px',
        fontFamily: '"Inter", -apple-system, BlinkMacSystemFont, sans-serif'
      }}>
        UGITS
      </h1>
      <p style={{
        fontSize: '14px',
        color: '#6b7280',
        margin: '8px 0 0 0',
        fontWeight: '500',
        letterSpacing: '0.5px'
      }}>
        Unidade de Gestão da Inovação<br/>Tecnológica em Saúde
      </p>
    </div>
  );
};

export default UgitsLogo;